import React, { useMemo } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import SearchUserInput from 'components/SearchUserInput/SearchUserInput';

import { customRequestTypes } from 'features/creativeFunctionality/models/customRequestsModel/data';
import CheckBox from 'components/CheckBox';
import './FilterBlock.scss';

const b = block('filter-block-custom-requests');

const FilterBlock = ({ model }) => {
  const { input } = model;
  const locale = useSelector(state => state.locale.locale);

  const StatusElements = useMemo(
    () =>
      input.values.statuses.map(status => (
        <div key={status.name} className={b('status')}>
          <CheckBox checked={status.active} onChange={input.onChangeStatuses} name={status.name} />
          <span className={b('status-text')}>{locale[status.name]}</span>
        </div>
      )),
    [input.values.statuses],
  );

  return (
    <form className={b()} onSubmit={input.handleFormSubmit} onKeyDown={input.handleKeyDown} tabIndex={0}>
      <div className={b('header')}>{locale.filter}</div>
      <div className={b('top')}>
        <div className={b('inputs')}>
          <div className={b('input')}>
            <div className={b('title')}>{locale.requestType}</div>
            <Select
              name="type"
              items={customRequestTypes}
              activeItem={input.values.type}
              onChange={input.handleTypeChange}
            />
          </div>
          <div className={b('input')}>
            <div className={b('title')}>{locale.username}</div>
            <SearchUserInput
              filterValue={input.filterValue}
              handleSearchChange={input.handleSearchChange}
              handleResultClick={input.handleResultClick}
              searchResult={input.searchResult}
              isLoadingSearchResult={input.isLoadingSearchResult}
              placeholder={locale.username}
              locale={locale}
            />
          </div>
          <div className={b('date')}>
            <div className={b('date-row')}>
              <div className={b('title')}>{locale.dateFrom}</div>
              <div className={b('date-input')}>
                <InputDate showTimeSelect selected={input.date.beginDate} onChange={input.onChangeBeginDate} />
              </div>
            </div>
            <div className={b('date-row')}>
              <div className={b('title')}>{locale.dateTo}</div>
              <div className={b('date-input')}>
                <InputDate showTimeSelect selected={input.date.endDate} onChange={input.onChangeEndDate} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={b('bottom')}>
        <div className={b('statuses')}>{StatusElements}</div>
        <div className={b('button')}>
          <Button size="low" text={locale.acceptFilter} type="submit" />
        </div>
      </div>
    </form>
  );
};

export default FilterBlock;
